var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DynamicComponent',{attrs:{"edc-id":"polaris-mall-purchase","framework":"Vue","edc-dev":_vm.edcDev}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }